import { render, staticRenderFns } from "./CieloFooter.vue?vue&type=template&id=4288f2f2&scoped=true"
import script from "./CieloFooter.vue?vue&type=script&lang=js"
export * from "./CieloFooter.vue?vue&type=script&lang=js"
import style0 from "./CieloFooter.vue?vue&type=style&index=0&id=4288f2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288f2f2",
  null
  
)

export default component.exports